<template>
  <v-container
    fluid
    class="py-5 px-5 py-sm-15 px-sm-10 fill-height align-start"
  >
    <v-row>
      <v-col>
        <v-row>
          <v-col class="text-start">
            <span class="textLight--text font-weight-medium text-h5">
              {{ $t("user.employees.employees") }} &
              {{ $t("user.employees.roles") }}
            </span>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-tabs
              v-model="selectedTab"
              color="primary"
              background-color="transparent"
            >
              <v-tab v-for="(item, index) in tabs" :key="index">
                <div
                  class="d-flex justify-center align-center py-4"
                  style="min-width: 130px"
                >
                  <v-icon size="30" class="px-2">{{ item.icon }}</v-icon>

                  <span>{{ item.text }}</span>
                </div>
              </v-tab>
            </v-tabs>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-tabs-items v-model="selectedTab" class="transparent">
              <v-tab-item :transition="false">
                <Employees :defaultRole="defaultRoleVal" />
              </v-tab-item>

              <v-tab-item :transition="false">
                <SubRoles />
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Employees from "@/app/user-module/components/Employees";
import SubRoles from "@/app/user-module/components/SubRoles";

export default {
  name: "EmployeesRolesPage",
  components: { SubRoles, Employees },
  data() {
    return {
      selectedTab: 0,
      defaultRoleVal: null,
    };
  },
  computed: {
    tabs() {
      const items = [
        {
          icon: "mdi-account-outline",
          text: this.$t("user.employees.employees"),
        },
      ];

      if (this.havePermissionGetSubRoles) {
        items.push({
          icon: "mdi-account-key-outline",
          text: this.$t("user.employees.roles"),
        });
      }

      return items;
    },
    havePermissionGetSubRoles() {
      return !this.$store.state.authenticatedUser?.isOrganizationManager;
    },
  },
  mounted() {
    this.defaultRoleVal = this.$route?.params?.role
      ? this.$route?.params?.role
      : null;
  },
};
</script>
